export default [
    {
        path: '/calculation-menus',
        name: 'calculation-menu',
        meta: { requiresAuth: true },
        component: () => import('@/pages/calculation-menu/index.vue')
    }
]
